// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './utils/vuexAlongSelfHeal' //自愈:必须在 store(vuex-along)初始化前清除损坏的 localStorage 数据
import Vue from 'vue'
import App from './App'
import ElementUI, { Option } from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/theme/index.css'
import validates from '@/assets/script/validationRule.js' //全局验证
import VirtualCollection from 'vue-virtual-collection'
import dataV from '@jiaminghi/data-view'
import router from './router'
import Moment from 'moment'
import Echarts from 'echarts'
import 'echarts/map/js/china'

import store from './store/index'


import '@/assets/style/common.css'
import VueCropper from 'vue-cropper' 
import 'babel-polyfill'


Vue.use(VueCropper)
// el-select filterable 输入去除前后空格:包装 Option.queryChange(须在 Vue.use(ElementUI) 之前,extend 才会用新方法)
if (Option && Option.methods && Option.methods.queryChange) {
  const __origOptionQueryChange = Option.methods.queryChange;
  Option.methods.queryChange = function (query) {
    return __origOptionQueryChange.call(this, (query == null ? '' : String(query)).trim());
  };
}
Vue.use(ElementUI);
Vue.use(validates)//验证js
Vue.use(dataV)

Vue.use(VirtualCollection) //多选框组无限滚动

Vue.config.productionTip = false
//vue-context-menu鼠标右键菜单
import VueContextMenu from 'vue-contextmenu'
Vue.use(VueContextMenu)
// 引入 axios 文件
import api from './axios_api/index.js'
// 绑定 axios 到全局（vue对象原型方法）
Vue.prototype.$api = api
Vue.prototype.echarts = Echarts 
Vue.use(Echarts)

// 图形验证码
import SlideVerify from 'vue-monoplasty-slide-verify';
Vue.use(SlideVerify);

// 引入二次确认弹窗
import confirms from './assets/script/confirm.js'
Vue.prototype.$confirms=confirms

//全局方法
import common from './assets/script/common.js'
Vue.prototype.$common = common

// 获取公司地址
import comAddress from './assets/script/comAddress.js'
Vue.prototype.$comAddress = comAddress
//获取运营商
import operators from './assets/script/operators.js'
Vue.prototype.$operators = operators


import directive from './utils/directive.js'
Vue.use(directive)

// 引入 导出下载 文件
import Files from './axios_api/exportFile.js'
// 绑定 导出下载 到全局（vue对象原型方法）
Vue.prototype.$File = Files;

Vue.prototype.moment = Moment

//md5加密
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;
//接口路径配置
import globalPath from '@/assets/script/globalPath.vue' 
Vue.prototype.API = globalPath.globalPath //接口路径配置

import VueResource from 'vue-resource' //使用的json数据
Vue.use(VueResource)

import * as filters from '@/assets/script/filters.js'
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})


// beforeunload事件在窗口、文档或其资源即将被卸载时触发。你可以在这个事件的处理函数中清除特定的localStorage项。
window.addEventListener('beforeunload', function (event) {
  console.log('beforeunload事件触发了');
  // 清除localStorage中的特定项
  document.cookie = 'uniquePageKey = true;path=/;domain=tibiot.com; max-age=0';
});
// 页面即将被关闭或切换标签
window.addEventListener('pagehide', function(event) {
  console.log('pagehide即将发生');
  document.cookie = 'uniquePageKey = true;path=/;domain=tibiot.com; max-age=0';
});
// 添加主题切换方法到Vue原型
Vue.prototype.$toggleTheme = function() {
  const app = document.getElementById('app').__vue__
  app.toggleTheme()
}

window.Vue = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js